// src/shared/components/layout/Header.tsx

import React from 'react';
import { useAppContext } from '../../context/AppContext';
import { authService } from '../../../modules/auth/services/authService';
import './Header.css';
import Logo from '../ui/Logo';

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { state, dispatch } = useAppContext();
  const { auth } = state;
  const [userMenuOpen, setUserMenuOpen] = React.useState(false);

  const handleLogout = () => {
    authService.logout();
    dispatch({ type: 'AUTH_LOGOUT' });
    setUserMenuOpen(false);
  };

  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
  };

  const closeUserMenu = () => {
    setUserMenuOpen(false);
  };

  // Cerrar menú al hacer click fuera
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('.user-menu-container')) {
        closeUserMenu();
      }
    };

    if (userMenuOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [userMenuOpen]);

  return (
    <header className="app-header">
      <div className="header-content">
        {/* Lado izquierdo - Logo y menú hamburguesa */}
        <div className="header-left">
          <button 
            className="sidebar-toggle"
            onClick={onToggleSidebar}
            aria-label="Toggle sidebar"
          >
            <span className="hamburger-icon">☰</span>
          </button>
          
          <div className="header-logo">
            <Logo 
  variant="default" 
  size="md"
  onClick={() => console.log('Navigate to home')}
/>
          </div>
        </div>

        {/* Centro - Búsqueda (futuro) */}
        <div className="header-center">
          <div className="search-container">
            <input 
              type="text" 
              placeholder="Buscar..." 
              className="search-input"
              disabled
            />
            <span className="search-icon">🔍</span>
          </div>
        </div>

        {/* Lado derecho - Notificaciones y usuario */}
        <div className="header-right">
          {/* Notificaciones (futuro) */}
          <button className="notification-btn" disabled>
            <span className="notification-icon">🔔</span>
            <span className="notification-badge">3</span>
          </button>

          {/* Menú de usuario */}
          <div className="user-menu-container">
            <button 
              className="user-menu-trigger"
              onClick={toggleUserMenu}
              aria-expanded={userMenuOpen}
            >
              <img 
                src={auth.user?.picture || ''} 
                alt={auth.user?.name || 'Usuario'}
                className="user-avatar"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(auth.user?.name || 'Usuario')}&background=667eea&color=fff`;
                }}
              />
              <span className="user-name">{auth.user?.name}</span>
              <span className={`dropdown-arrow ${userMenuOpen ? 'open' : ''}`}>▼</span>
            </button>

            {/* Dropdown del usuario */}
            {userMenuOpen && (
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <div className="user-info">
                    <strong>{auth.user?.name}</strong>
                    <div className="user-email">{auth.user?.email}</div>
                  </div>
                </div>
                
                <div className="dropdown-divider"></div>
                
                <div className="dropdown-menu">
                  <button className="dropdown-item" disabled>
                    <span>👤</span>
                    Perfil
                  </button>
                  <button className="dropdown-item" disabled>
                    <span>⚙️</span>
                    Configuración
                  </button>
                  <button className="dropdown-item" disabled>
                    <span>❓</span>
                    Ayuda
                  </button>
                  
                  <div className="dropdown-divider"></div>
                  
                  <button className="dropdown-item logout-item" onClick={handleLogout}>
                    <span>🚪</span>
                    Cerrar Sesión
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;